import {
    UserFunctionAnchor,
    UserFunctionVersion,
} from 'src/models/anchor-and-version/user-function.model';
import { Component } from '@angular/core';
import { CrudBaseModalComponent } from '../crud-base-modal/crud-base-modal.component';
import { CrudModalAbstractComponent } from '../crud-base-modal/crud-modal-abstract.component';
import { ModalProps } from '../crud-base-modal/modal-field.interface';

@Component({
    selector: 'app-crud-user-function-modal',
    template: `<app-crud-base-modal #baseModal [modalProps]="modalProps"></app-crud-base-modal>`,
    imports: [CrudBaseModalComponent],
})
export class CrudUserFunctionModalComponent extends CrudModalAbstractComponent<
    UserFunctionAnchor,
    UserFunctionVersion
> {
    public modalProps: ModalProps = {
        title: 'User Function',
        anchorFields: [
            {
                field: 'userFunctionId',
                label: 'User Function Id',
                type: 'number',
                required: true,
                order: 2,
                uniqueCheck: true,
            },
            {
                field: 'functionCategoryAnchorKey',
                label: 'Function Category',
                type: 'lazy-dropdown',
                required: true,
                order: 3,
            },
        ],
        versionFields: [
            {
                field: 'changeRequestKey',
                label: 'Change Request',
                type: 'lazy-dropdown',
                required: true,
                order: 1,
            },
            { field: 'name', label: 'Name', type: 'text', required: true, order: 4 },
            { field: 'oasFpc', label: 'OAS FPC', type: 'text', order: 5 },
            { field: 'documentation', label: 'Documentation', type: 'textarea', order: 6 },
            { field: 'englishDefinition', label: 'English Definition', type: 'textarea', order: 7 },
            { field: 'swedishDefinition', label: 'Swedish Definition', type: 'textarea', order: 8 },
            { field: 'swedishName', label: 'Swedish Name', type: 'text', order: 9 },
            { field: 'contactPerson', label: 'Contact Person', type: 'text', order: 10 },
            {
                field: 'contactPersonService',
                label: 'Contact Person Service',
                type: 'text',
                order: 11,
            },
            { field: 'responsiblePerson', label: 'Responsible Person', type: 'text', order: 12 },
            {
                field: 'responsiblePersonId',
                label: 'Responsible Person Id',
                type: 'text',
                order: 13,
            },
            { field: 'responsibleGroup', label: 'Responsible Group', type: 'text', order: 14 },
            { field: 'comment', label: 'Comment', type: 'textarea', order: 15 },
            { field: 'isActive', label: 'Is Active', type: 'switch', order: 16 },
        ],
    };
}
